var _mask, _mask2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M160 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24 24 24 0 0 0 0-.2v-24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M0 128h512v256H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 304h-16v-80h16zm128 0h16v-80h-16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208,
    cy: 296,
    rx: 48,
    ry: 32
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    x: 128,
    y: 192,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    x: 272,
    y: 192,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24 24 24 0 0 0 0-.2v-24h-24z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff9811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 208,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 208,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 304,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 304,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24 24 24 0 0 0 0-.2v-24h-24z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#d80027",
    strokeLinecap: "round",
    d: "M122 252h172m-172 24h28m116 0h28"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44",
    stroke: "#eee"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 194,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 184,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 194,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 184,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff9811",
    d: "M220 284v12c0 7 5 12 12 12s12-5 12-12v-12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M200 160h16v32h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M208 224h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24zm-88 16h48v48h-48z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 32,
    x: 222,
    y: 232,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 272h10v48h-10zm19 0h10v48h-10z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M168 232v8h8v16h-8v8h32v-8h-8v-16h8v-8zm8-16h64v8h-64z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 202,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 202,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 202,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#338af3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 272,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 320,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 320,
    ry: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.70d5125d6892f8e84d99a1e83a52ce87.svg";
export { ForwardRef as ReactComponent };